(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alp-abandoned-checkout-popup"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    let cookie = document.cookie;
    if (cookie.includes('alp_abandoned_checkout_triggered=true')) {
      popupOpen();
      document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
    }

    let triggerButtons = document.querySelectorAll(`[type="submit"]#checkout, .alp-payment-button-wrapper`);
    triggerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        document.cookie = 'alp_abandoned_checkout_triggered=true; path=/; max-age=86400';
      });
    });

    function globoPopupButtonControl(globoElement) {
      let interval = setInterval(() => {
        let button = globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]');
        let buttonText = button.textContent;
        if (buttonText.includes('Submit')) {
          globoElement.classList.add('is-last-step');
        } else {
          globoElement.classList.remove('is-last-step');
        }
      }, 400);

      let closeButton = globoElement.querySelectorAll('.header.dismiss , .overlay');
      closeButton.forEach(function (button) {
        button.addEventListener('click', function () {
          clearInterval(interval);
          if (globoElement.classList.contains('is-last-step')) {
            globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]').click();
          }
        });
      });
    }

    function popupOpen() {
      let popupId = document.querySelector('.alp-abandoned-checkout-popup[data-id]').getAttribute('data-id');
      let delay = document.querySelector('.alp-abandoned-checkout-popup[data-delay]').getAttribute('data-delay');
      delay = parseInt(delay);
      if (popupId) {
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', popupId]);
          console.log('Abandoned checkout popup opened');
        }, delay);
      }
      //
      let globoElement = document.querySelector('.globo-formbuilder-popup');
      if (globoElement) {
        globoElement.querySelector('.globo-form .floating-button').click();
        // globoPopupButtonControl(globoElement);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      // check if the codes can not combine, return the applied codes that can be combined
      codes = codesCanNotCombineCheck(window.codesCanNotCombineArray, codes);

      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message, error = false) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      if (error) {
        messageEl.classList.add('error');
      } else {
        messageEl.classList.remove('error');
      }
      setTimeout(() => {
        messageEl.classList.add('hidden');
        messageEl.classList.remove('error');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message, error = false) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`, error);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', codeToRemove);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init(loading = true) {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          if (loading) {
            form.classList.add('loading');
          } else {
            form.classList.add('updating');
          }
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
              form.classList.remove('updating');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
          form.classList.remove('updating');
        });
    }

    window.addEventListener('refreshAjaxCart', () => init(true));

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (thisCode && !thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`, true);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // codes can not combine
    function codesCanNotCombineCheck(codesNotCombineArray, appliedCodes) {
      codesNotCombineArray = codesNotCombineArray || [];
      appliedCodes = appliedCodes || [];

      if (codesNotCombineArray.length === 0 || appliedCodes.length === 0) {
        return appliedCodes;
      }

      let finalCodesToRemove = [];
      // for each codes in codesNotCombineArray, check if it is in appliedCodes
      for (let i = 0; i < codesNotCombineArray.length; i++) {
        if (appliedCodes.includes(codesNotCombineArray[i])) {
          finalCodesToRemove.push(codesNotCombineArray[i]);
        }
      }

      if (finalCodesToRemove.length > 1) {
        for (let i = 0; i < finalCodesToRemove.length; i++) {
          if (i > 0) {
            appliedCodes.splice(appliedCodes.indexOf(finalCodesToRemove[i]), 1);
          }
        }

        // show message
        // showMessage(`${finalCodesToRemove.join(', ')} are not combineable together.`);
        console.log('Codes Can Not Combine:', finalCodesToRemove);
        console.log('Final Applied Codes:', appliedCodes);
      }
      return appliedCodes;
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-variants-swatch"] && !Shopify.designMode) return;
  try {
    window.AXXVariantsSwatch = class {
    // 选择器 [data-axx-swatch]
    // 父级 [data-product-swatch]
    // 图片 [data-product-swatch-images]
    // 价格容器 [data-product-swatch-price]
    // 价格值 [data-product-swatch-price-value]
    // 对比价格 [data-product-swatch-compare-price-value]
    // url [data-product-swatch-url]

    constructor() {
      this.products = [];
      // 存储事件处理函数
      this.eventListeners = new Map();
    }

    init() {
      this.products = document.querySelectorAll('[data-axx-swatch]');
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 创建事件处理函数
        const handler = (e) => this.handlerChange(product, form);
        // 存储事件处理函数
        this.eventListeners.set(form, handler);
        // 添加事件监听器
        form.addEventListener('change', handler);
      });
    }

    update() {
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 获取存储的事件处理函数
        const handler = this.eventListeners.get(form);
        if (handler) {
          // 移除事件监听器
          form.removeEventListener('change', handler);
          // 清理存储的引用
          this.eventListeners.delete(form);
        }
      });
      this.products = [];
      this.init();
    }

    handlerChange(product, form) {
      const fieldsets = Array.from(form.querySelectorAll('[data-form-input]'));
      let options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      this.updateCurrentVariant(product, options);
    }

    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }
      return true;
    }

    getVariantData(product) {
      let variantData = JSON.parse(product.querySelector('[type="application/json"]').textContent);
      return variantData;
    }

    updateCurrentVariant(product, options) {
      let currentVariant = null;
      this.getVariantData(product).find((variant) => {
        // match the current variant
        if (this.areArraysEqual(variant.options, options)) {
          currentVariant = variant;
        }
      });
      // console.log(currentVariant.id);
      if (currentVariant) {
        this.setProductInfo(product, currentVariant);
        this.updateVariantStatuses(product, currentVariant);
      }
    }

    updateVariantStatuses(product, currentVariant) {
      let $this = this;
      let forms = product.querySelector('form').querySelectorAll('[data-form-input]');
      if (forms.length < 2) {
        return;
      }
      // Disable all inputs
      forms.forEach((form) => {
        form.querySelectorAll('input').forEach((input) => {
          input.classList.add('disabled');
        });
      });
      // Enable only the matched inputs
      forms.forEach((form, index) => {
        let checkedInput = form.querySelector(':checked');
        let matchedVariants = $this
          .getVariantData(product)
          .filter((variant) => variant.options[index] === checkedInput.value);
        // console.log(matchedVariants);
        matchedVariants.forEach((variant) => {
          let available = variant.available;
          variant.options.forEach((option, optionIndex) => {
            if (optionIndex !== index) {
              // console.log(option);
              let optionInputs = forms[optionIndex].querySelectorAll(`input[value="${option}"]`);
              optionInputs.forEach((input) => {
                if (available) {
                  input.classList.remove('disabled');
                }
              });
            }
          });
        });
      });
    }

    setProductInfo(product, variant) {
      let productId = product.dataset.productId;
      let productUrl = product.dataset.productUrl;
      let productUrlWithVariant = productUrl + '?variant=' + variant.id;
      let productInfo = {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        image: variant.featured_image.src,
        image_id: variant.featured_image.id,
        url: productUrlWithVariant,
        options: variant.options,
        available: variant.available,
      };
      this.updateProductInfo(product, productId, productInfo);
      this.sendCustomEvent(product, productId, 'variant:change', productInfo);
      // console log
      console.log(`SwatchChanged:[product:${productId}],[variant:${variant.id}]`);
    }

    updateProductInfo(product, productId, productInfo) {
      // match the parent element '[data-product-swatch]'
      let parent = product.closest('[data-product-swatch]');
      // update product data info
      if (parent) {
        parent.dataset.productInfo = JSON.stringify(productInfo);
        // update images src and srcset
        let images = parent.querySelectorAll(`[data-product-swatch-images]`);
        if (images) {
          images.forEach((image) => {
            let imageInfo = JSON.parse(image.querySelector('[type="application/json"]').textContent);
            imageInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                image.querySelector('img').src = variant.image.src;
                image.querySelector('img').srcset = variant.image.srcset;
              }
            });
          });
        }
        // update price
        let priceWarpper = parent.querySelectorAll('[data-product-swatch-price]');
        if (priceWarpper) {
          priceWarpper.forEach((price) => {
            let the_price = price.querySelector('[data-product-swatch-price-value]');
            let the_compare_price = price.querySelector('[data-product-swatch-compare-price-value]');
            let priceInfo = JSON.parse(price.querySelector('[type="application/json"]').textContent);
            priceInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                the_price.textContent = variant.price;
                the_compare_price.textContent = variant.compare_at_price;
                if (variant.compare_at_price) {
                  the_compare_price.classList.remove('hidden');
                } else {
                  the_compare_price.classList.add('hidden');
                }
              }
            });
          });
        }
        // update url
        let urlWarpper = parent.querySelectorAll('[data-product-swatch-url]');
        if (urlWarpper) {
          urlWarpper.forEach((url) => {
            url.setAttribute('href', productInfo.url);
          });
        }
      }
    }

    sendCustomEvent(product, productId, eventName, detail) {
      let parent = product.closest('[data-product-swatch]');
      if (parent) {
        let event = new CustomEvent(eventName, { detail });
        parent.dispatchEvent(event);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.axxVariantsSwatch = new window.AXXVariantsSwatch();
    window.axxVariantsSwatch.init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-trustpilot"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {});
  } catch(e) { console.error(e); }
})();

})();
